// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_gb-0";
export var animationContainer = "_gb-1";
export var modalContent = "_gb-2";
export var orderName = "_gb-3";
export var refundOption = "_gb-4";
export var refundOptionsContainer = "_gb-5";